var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaySymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 12 16",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.9699497 9.7321234c1.3820862-.9083257 1.3770085-2.3845724 0-3.2898332l-8.46746128-5.5666044c-1.38208619-.9085991-2.50248842-.2994085-2.50248842 1.3592997v11.7022732c0 1.6593195 1.12547995 2.2647832 2.50248842 1.3597946z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaySymbol);
export default __webpack_public_path__ + "static/media/play-symbol.56d515418884896d7596f42fb298069e.svg";
export { ForwardRef as ReactComponent };